/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * A segment tracking shaped version of what was purchased
 */
export interface Product {
  product_id: string;
  name: string;
  category: string;
  quantity?: number;
  price?: number | null;
}
